module.exports = __webpack_public_path__ + "static/media/spinner.54d16dec.gif";